<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <FolderHome /> -->
  </div>
</template>

<script>
// import FolderHome from "vue-material-design-icons/FolderHome.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiFolderHome } from "@mdi/js"

export default {
  name: "FolderHomeIcon",
  components: {
    SvgIcon
    // FolderHome,
  },
  data() {
    return {
      path: mdiFolderHome,
    }
  }
}
</script>
